window.trustbox = function (d, s) {
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s);
    j.async = true;
    j.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    f.parentNode.insertBefore(j, f);
};
